import { DatiRichiedenteDTO } from "./dati-richiedente-dto";
import { IdentificativoRichiestaDTO } from "./identificativo-richiesta-dto";
import { RappresentanteDTO } from "./rappresentante-dto";

export class BozzaDepositoDTO<T>{
	datiRichiedente: DatiRichiedenteDTO;
	datiSpecificiDeposito: T;
	identificativoRichiesta: IdentificativoRichiestaDTO;
	rappresentanza: RappresentanteDTO;
}